'use client';
import { type ReactNode, useState } from 'react';

import { Tabs } from '@gds/Tabs/Tabs';

import styles from './SearchFormTabs.module.css';

interface Tab {
  label: string;
  content: ReactNode;
}

interface SearchFormTabsProps {
  tabs: Tab[];
  idPrefix: string;
}

const SearchFormTabs = ({ tabs, idPrefix }: SearchFormTabsProps) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (i: number) => {
    setActiveTab(i);
  };

  const buttons = tabs.map(t => ({ label: t.label }));
  const tabContents = tabs.map((t, i) => (activeTab === i ? t.content : null));

  return (
    <Tabs
      idPrefix={idPrefix}
      activeIndex={activeTab}
      buttons={buttons}
      className={styles.wrapper}
      onChange={i => handleTabChange(i)}
      tabContents={tabContents}
    />
  );
};

export default SearchFormTabs;
